import { useState, useEffect } from 'react';
import useStore from "../../../useStore";

export const useCarrito = (isMobile) => {
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [carritoVisible, setCarritoVisible] = useState(false);

  useEffect(() => {
    const productosEnCarrito = useStore.getState().carritoProductos;
    
    if (productosEnCarrito && productosEnCarrito.length > 0) {
      setProductosSeleccionados(productosEnCarrito);
      if (isMobile) {
        setCarritoVisible(true);
      }
      useStore.getState().vaciarCarrito();
    }
  }, [isMobile]);

  const toggleCarrito = () => {
    if (isMobile) {
      setCarritoVisible(!carritoVisible);
    }
  };

  const agregarProducto = (producto) => {
    const productoConEsVino = {
      ...producto,
      esVino: producto.esVino === true
    };
    
    const index = productosSeleccionados.findIndex(
      p => (p._id || p.id) === (productoConEsVino._id || productoConEsVino.id)
    );
    
    if (index !== -1) {
      const nuevosProductos = [...productosSeleccionados];
      nuevosProductos[index] = {
        ...nuevosProductos[index],
        cantidad: (nuevosProductos[index].cantidad || 1) + 1
      };
      setProductosSeleccionados(nuevosProductos);
    } else {
      setProductosSeleccionados([
        ...productosSeleccionados,
        { 
          ...productoConEsVino, 
          cantidad: 1
        }
      ]);
    }
  };

  const eliminarProducto = (index) => {
    const nuevosProductos = [...productosSeleccionados];
    nuevosProductos.splice(index, 1);
    setProductosSeleccionados(nuevosProductos);
  };

  const actualizarCantidad = (index, nuevaCantidad) => {
    const nuevosProductos = [...productosSeleccionados];
    if (nuevaCantidad <= 0) {
      eliminarProducto(index);
    } else {
      nuevosProductos[index].cantidad = nuevaCantidad;
      setProductosSeleccionados(nuevosProductos);
    }
  };

  const limpiarCarrito = () => {
    setProductosSeleccionados([]);
    if (isMobile) {
      setCarritoVisible(false);
    }
  };

  return {
    productosSeleccionados,
    carritoVisible,
    setCarritoVisible,
    toggleCarrito,
    agregarProducto,
    eliminarProducto,
    actualizarCantidad,
    limpiarCarrito
  };
};